import React, { useState, useMemo, useEffect, useRef } from "react";
import {
	Select,
	Breadcrumb,
	Button,
	CollapseTree,
	FilterBar,
	PickListDropdown,
	Table,
	AuthProvider,
	AuthMachine,
	Modal,
	Icon,
	Pagination,
	getUserAuthorityPreference,
} from "common-components";
import { fetchMachine, FetchEventType, FetchStates } from "machines/fetchMachine";
import { useMachine } from "@xstate/react";
import { getBankSelection, getBankBookSelection, getBankQuestion } from "api/bank";
import { getRecordDetail } from "api/convert";
import { DragDropList } from "components";
import { exportFile } from "api/export";
import { setSelectOptions, sliceTableData, search, blobDownload } from "utils/common";
import { Checkbox, Tabs, Image } from "antd";
import { format } from "date-fns";
import { HeadphonesSolid } from "@onedesign/icon";
import openNotificationWithIcon from "utils/hooks/useNotification";
import { UiQuestionSearchPage, UiQuesDetail, UiPopupContainer } from "./QuestionSearchPage.style";
/**
 * 試題查詢頁面
 */

const breadcrumbList = [
	{
		icon: "find_in_page",
		name: "試題查詢",
		path: "/questionSearch",
	},
];

const args = {
	isLoading: false,
	isSticky: true,
};
const initSendFormData = {
	education: "",
	subject: "",
	version: "",
	year: "",
};

const defaultColumnData = [
	{
		id: "uid",
		code: "uid",
		value: "試題ID",
		isdefault: true,
	},
	{
		id: "descContent",
		code: "descContent",
		value: "試題內容",
		isdefault: true,
	},
	{
		id: "QUES_TYPE",
		code: "QUES_TYPE",
		value: "題型",
		isdefault: true,
	},
	{
		id: "KNOWLEDGE",
		code: "KNOWLEDGE",
		value: "知識向度",
		isdefault: true,
	},
	{
		id: "SOURCE",
		code: "SOURCE",
		value: "出處",
		isdefault: true,
	},
];

const defaultSchema = {
	uid: {
		name: "試題ID",
		defaultValue: "",
	},
	descContent: {
		name: "試題內容",
		defaultValue: "--",
	},
	QUES_TYPE: {
		name: "題型",
		defaultValue: "",
	},
	KNOWLEDGE: {
		name: "知識向度",
		defaultValue: "",
	},
	SOURCE: {
		name: "出處",
		defaultValue: "--",
	},
};

const questionDisplayTypeOptions = [
	{
		name: "全部試題",
		value: "all",
	},
	{
		name: "已選試題",
		value: "choice",
	},
	{
		name: "未選試題",
		value: "notChoice",
	},
];

const listenFilterArray = {
	code: "ISLISTEN",
	map: [
		{ code: "all", name: "全部" },
		{ code: "notListen", name: "非聽力題" },
		{ code: "listen", name: "聽力題" },
	],
	name: "是否為聽力題",
};
const showCodeList = ["CORE_ACCOMPLISHMENT", "PERFORMANCE", "LEARN_CONTENT", "KNOWLEDGE"];
const { useAuthState, useAuthDispatch } = AuthProvider;
const { eventType: AuthEventType } = AuthMachine;
export const QuestionSearchPage = () => {
	const authState = useAuthState();
	const authDispatch = useAuthDispatch();
	const userColConfig = authState.context.result.preference.columnOptions || [];
	const tableRef = useRef(null);
	const [list, setList] = useState(defaultColumnData);
	const [modalVisible, setModalVisible] = useState({
		drag: false,
	});
	const [questionDisplayType, setQuestionDisplayType] = useState("all");
	const [checkedList, setCheckedList] = useState([]); //["0-0-0"]
	const [filterParams, setState] = useState({
		name: "",
		ISLISTEN: "notListen",
	});

	const [sendFormData, setSendFormData] = useState(initSendFormData);

	const [dataFetching, setDataFetching] = useState(false);
	const [treeActiveKey, setTreeActiveKey] = useState(null);
	const [quesIDList, setQuesIDList] = useState([]);

	const [questionData, setQuestionData] = useState([]);

	const [pageState, setPageState] = useState({
		currentPage: 1,
		limit: 10,
	});

	const [tableColumn, setTableColumn] = useState(defaultSchema);

	const [detailUID, setDetailUID] = useState("");

	const [bookTagPath, setBookTagPath] = useState("");

	const [bookTagIsListen, setBookTagIsListen] = useState(false);

	const [detailPopup, setDetailPopup] = useState({
		visible: false,
	});

	const [stateExportFile, sendExportFile] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				const { data, isSuccess, message } = await exportFile(event.payload);
				return {
					isSuccess,
					message,
					fileUrl: data,
				};
			},
		},
	});

	const [stateSelect, sendSelect] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_context, event) => {
				const result = await getBankSelection();
				const {
					data: { yearMap, eduMap, eduVersion, eduSubject },
				} = result;
				return {
					eduSubject: eduSubject || {},
					eduVersion: eduVersion || {},
					eduMap: eduMap ? setSelectOptions(eduMap) : [],
					yearMap: yearMap ? setSelectOptions(yearMap) : [],
				};
			},
		},
	});

	const [stateBookSelect, sendBookSelect] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_context, event) => {
				const result = await getBankBookSelection(event.payload);
				const {
					data: { bookMap },
				} = result;
				return {
					bookMap,
				};
			},
		},
	});

	const [stateBankQuestion, sendBankQuestion] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_context, event) => {
				const result = await getBankQuestion(event.bookID);
				const {
					isSuccess,
					message,
					data: { chapters, questions = [], filter, bookID },
				} = result;
				const allCheckedData = getAllChecked(chapters);
				let nextFilter = filter;
				if (nextFilter) nextFilter.splice(5, 0, listenFilterArray);
				return {
					isSuccess,
					message,
					knowledgeMap: getKnowledgeMap(chapters),
					allCheckedData,
					filter: nextFilter ? nextFilter.reverse() : [],
					treeData: formateKnowledge(chapters),
					questionsBookID: bookID,
					questions: questions.map((item) => {
						let quesInfo = {};
						item.metadata.forEach((info) => {
							let infoVal = "";
							if (!info.content) {
								quesInfo = {
									...quesInfo,
									[info.code]: null,
								};
							} else {
								for (let i = 0; i < info.content.length; i++) {
									infoVal += `${info.content[i].name}${i + 1 < info.content.length ? "," : ""}`;
								}
								quesInfo = {
									...quesInfo,
									[info.code]: infoVal,
								};
							}
						});
						return {
							...item,
							...quesInfo,
							descContent: item.content.content || "--",
						};
					}),
				};
			},
		},
	});

	const [stateUserAuthorityPreference, sendUserAuthorityPreference] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_context, event) => {
				const { isSuccess, message } = await getUserAuthorityPreference(process.env.REACT_APP_DOMAIN, event.payload);
				openNotificationWithIcon("success", "更改設定成功！");
				return {
					isSuccess,
					message,
				};
			},
		},
	});

	const [stateRecordDetail, sendRecordDetail] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				const { data } = await getRecordDetail(event.eduSubject, event.fileUID);
				return {
					detailList: data,
				};
			},
		},
	});

	const { eduSubject, eduVersion, eduMap, yearMap } = stateSelect.context.result || {};
	const { bookMap } = stateBookSelect.context.result || {};
	const { knowledgeMap, filter, treeData, questions, allCheckedData, questionsBookID } =
		stateBankQuestion.context.result || {};
	const { detailList } = stateRecordDetail.context.result || {};
	const { fileUrl } = stateExportFile.context.result || {};

	const eduVersionOption = useMemo(() => {
		if (!sendFormData.education || !eduVersion) return [];
		return setSelectOptions(eduVersion[`${sendFormData.education}`]);
	}, [sendFormData.education]);

	const eduSubjectOption = useMemo(() => {
		if (!sendFormData.education || !eduSubject) return [];
		return setSelectOptions(eduSubject[`${sendFormData.education}`]);
	}, [sendFormData.education]);

	const filterDisplayData = (data) => {
		switch (questionDisplayType) {
			case "choice":
				return data.filter(
					(item) =>
						quesIDList.find((ele) => ele.bookID === item.bookID).iDs.findIndex((ele) => ele === item.uid) !== -1,
				);
			case "notChoice":
				return data.filter(
					(item) =>
						quesIDList.find((ele) => ele.bookID === item.bookID).iDs.findIndex((ele) => ele === item.uid) === -1,
				);
			case "all":
			default:
				return data;
		}
	};

	const filterQuestionsIsListen = (type, data) => {
		let result = [];

		switch (type) {
			case "notListen":
				result = result.concat(data.filter((item) => !item.isListen));
				break;
			case "listen":
				result = result.concat(data.filter((item) => item.isListen));
				break;
			case "all":
			default:
				result = data;
				break;
		}
		return result;
	};

	const filterTableData = useMemo(() => {
		if (!questionData || questionData.length === 0) return [];
		if (!knowledgeMap || !checkedList || checkedList.length === 0) return [];
		let choiceKnowledge = [];
		checkedList.forEach((item) => {
			if (knowledgeMap[item]) {
				choiceKnowledge = choiceKnowledge.concat(knowledgeMap[item]);
			}
		});
		let displayData = filterDisplayData(questionData);
		displayData = filterQuestionsIsListen(filterParams.ISLISTEN, displayData);

		const newData = displayData
			.filter((item) => {
				let isDuplicate = false;
				item?.key &&
					item.key.forEach((ele) => {
						isDuplicate = choiceKnowledge.filter((knowledge) => ele === knowledge).length > 0;
					});

				return isDuplicate;
			})
			.filter((item) => {
				if (!item.descContent) return true;
				return search(filterParams.name, item.descContent);
			})
			.filter((item) => {
				let result = true;
				for (const element of item.metadata) {
					if (element.code in filterParams) {
						if (element.code === "QUES_TYPE" || element.code === "SOURCE") {
							if (Object.keys(filterParams[element.code]).length === 0) {
								result = true;
							} else {
								result =
									element.content.filter((item) => {
										for (const prop in filterParams[element.code]) {
											if (element.code === "SOURCE") {
												if (prop === item.code) {
													return true;
												}
											} else {
												if (filterParams[element.code][prop].findIndex((data) => data === item.code) !== -1) {
													return true;
												}
											}
										}
									}).length > 0;
							}
						} else {
							result =
								element.content.filter((item) =>
									element.code === "DIFFICULTY"
										? item.name === filterParams[element.code]
										: item.code === filterParams[element.code],
								).length > 0;
						}
					}
					if (!result) break;
				}

				return result;
			});
		return newData;
	}, [checkedList, questionData, filterParams, questionDisplayType]);

	const confirmDisabled = useMemo(() => {
		return list.filter((item) => item.value === "").length > 0;
	}, [list]);

	const columnOptions = useMemo(() => {
		return filter
			? filter
					.filter((item) => [...Object.keys(tableColumn)].indexOf(item.code) === -1)
					.map((data) => ({
						id: data.code,
						code: data.code,
						value: data.name,
					}))
			: [];
	}, [filter, tableColumn]);

	const filterDisplay = useMemo(() => {
		if (!tableColumn) return [];
		const displayKey = Object.keys(tableColumn).concat("ISLISTEN"); //聽力
		return filter ? filter.filter((item) => [...displayKey].indexOf(item.code) !== -1) : [];
	}, [filter, tableColumn]);

	const getAllChecked = (arr) => {
		if (!arr || arr.length === 0) return [];
		let result = [];
		arr.forEach((item) => {
			result = [...result, item.code];
			if ("subChapter" in item) {
				item?.subChapter &&
					item.subChapter.forEach((subItem) => {
						result = [...result, subItem.code];
					});
			}
		});

		return result;
	};

	const formateKnowledge = (arr) => {
		if (!arr || arr.length === 0) return [];
		let result = [];
		result = arr.map((item) => {
			let children = [];
			if ("subChapter" in item) children = formateKnowledge(item.subChapter);
			if (children.length > 0) {
				return {
					title: `${item.code}. ${item.name}`,
					key: item.code,
					children,
				};
			} else {
				return {
					title: `${item.code}. ${item.name}`,
					key: item.code,
				};
			}
		});
		return result;
	};

	const getKnowledgeMap = (arr) => {
		if (!arr || arr.length === 0) return [];
		let result = {};
		arr.forEach((item) => {
			let children = [];
			if ("subChapter" in item) children = getKnowledgeMap(item.subChapter);
			if (Object.keys(children).length > 0) {
				result = {
					...result,
					...children,
				};
			} else {
				result = { ...result, [item.code]: item.knowledge || {} };
			}
		});
		return result;
	};

	const onChange = (checkedKeysValue) => {
		setCheckedList(checkedKeysValue);
	};

	const onPanelChange = async (key) => {
		if (!key) {
			setTreeActiveKey(null);
			return;
		}
		setCheckedList([]);
		setTreeActiveKey(key);
		await sendBankQuestion(FetchEventType.Fetch, { bookID: bookMap[key].code });
	};
	const subtraction = (arr1, arr2) => {
		if (!arr1) return [];
		return arr1.filter((e) => arr2.map((item) => item.code).indexOf(e.code) === -1);
	};
	const onDragEndChange = (arr) => {
		setList([...arr]);
	};

	const onAdd = () => {
		let largeNum = 0;
		list.forEach((item) => {
			if (parseInt(item.id) >= largeNum) largeNum = parseInt(item.id) + 1;
		});
		const newList = [...list, { id: largeNum.toString(), code: "", value: "" }];
		setList(newList);
	};
	const onDelete = (id) => {
		const newList = [...list].filter((item) => item.id !== id);
		setList(newList);
	};
	const onDragDropSelectChange = (option, id) => {
		const knowledgeList = list;
		const newDropList = knowledgeList.map((item) => {
			if (item.id === id) {
				if (option) {
					item.value = option.value;
					item.code = option.code;
				} else {
					item.code = "";
					item.value = "";
				}
			}
			return item;
		});
		setList(newDropList);
	};

	const formatTableColData = (list, defaultData = {}) => {
		let nextData = defaultData;
		list.forEach((item) => {
			nextData = {
				...nextData,
				[item.code]: {
					name: item.value,
					defaultValue: "--",
				},
			};
		});
		return nextData;
	};

	const changeColumn = async () => {
		const nextData = formatTableColData(list);
		setTableColumn(nextData);
		await sendUserAuthorityPreference(FetchEventType.Fetch, {
			payload: {
				type: "columnOptions",
				data: list,
			},
		});
		setModalVisible({
			...modalVisible,
			drag: false,
		});
	};

	const onSelectChange = (key, value) => {
		setSendFormData({
			...sendFormData,
			[key]: value,
		});
	};

	const pickListChange = (key, value) => {
		setState({
			...filterParams,
			[key]: value,
		});
	};
	const searchBookMap = () => {
		if (Object.entries(sendFormData).findIndex(([, val]) => val === "") !== -1) return;
		setTreeActiveKey(null);
		setCheckedList([]);
		setQuestionData([]);
		setQuesIDList([]);
		sendBookSelect(FetchEventType.Fetch, { payload: sendFormData });
	};

	const pageChange = (currentPage, pageSize) => {
		setPageState({
			...pageState,
			currentPage,
			limit: pageSize,
		});
		tableRef.current.scrollIntoView();
	};

	const tableCheck = (event, data) => {
		const checkedState = event.target.checked;
		const { uid: quesID, bookID } = data;
		const found = quesIDList.find((item) => item.bookID === bookID);
		if (found) {
			const dataIndex = quesIDList.findIndex((item) => item.bookID === bookID);
			let nextData = quesIDList;
			if (checkedState) {
				if (found.iDs.findIndex((item) => item === quesID) !== -1) return;

				nextData[dataIndex] = { ...nextData[dataIndex], iDs: [...found.iDs, quesID] };
				setQuesIDList([...nextData]);
			} else {
				nextData[dataIndex] = {
					...found,
					iDs: found.iDs.filter((item) => item !== quesID),
				};
				setQuesIDList([...nextData]);
			}
		} else {
			//無found情況下checkedState通常都是為true
			const nextData = {
				bookID,
				iDs: [].concat(quesID),
			};
			setQuesIDList([...quesIDList, nextData]);
		}
	};

	const onTabPickListChange = (key, value, innerKey) => {
		let nextData = { ...filterParams };
		if (value.length === 0) {
			delete nextData[key][innerKey];
		} else {
			nextData = {
				...nextData,
				[key]: { ...nextData[key], [innerKey]: value },
			};
		}
		setState({
			...nextData,
		});
	};

	const FormateFilterQuesType = (arr) => {
		if (!arr || arr.length === 0) return [];
		let result = [];
		result = arr.map((item) => {
			let children = [];
			if ("subMap" in item) children = FormateFilterQuesType(item.subMap);
			if (children.length > 0) {
				return {
					name: item.name,
					value: item.code,
					subMap: children,
				};
			} else {
				return {
					name: item.name,
					value: item.code,
				};
			}
		});
		return result;
	};

	const FormateSinglePickListDropdown = (arr, code = "") => {
		if (!arr || arr.length === 0) return [];
		let result = [];
		result = arr.map((item) => {
			let children = [];
			if ("subMap" in item) children = FormateSinglePickListDropdown(item.subMap);
			if (children.length > 0) {
				return {
					value: item.code,
					name: item.code,
					displayName: item.name,
					subMap: children,
				};
			} else {
				if (code === "ISLISTEN") {
					return {
						value: item.code,
						name: item.name,
						displayName: item.name,
					};
				} else {
					return {
						value: item.code,
						name: item.code,
						displayName: item.name,
					};
				}
			}
		});
		return result;
	};

	const setDifficultySelectOptions = (data, needNull = false) => {
		if (!data) return [];
		const result =
			data.length > 0
				? data.map((item) => {
						return { name: item.name, value: item.name };
				  })
				: [];

		if (needNull) {
			result.push({
				name: "---",
				value: "",
			});
		}
		return result;
	};

	const clearFilter = (code) => {
		if (code in filterParams) {
			const nextData = filterParams;

			delete nextData[code];
			setState({ ...nextData });
		}
	};

	const renderFilterBar = (item) => {
		const { code, map, name } = item;
		switch (code) {
			case "QUES_TYPE":
			case "SOURCE":
				return (
					<PickListDropdown.TabPickListDropdown
						defaultTitle={name}
						options={FormateFilterQuesType(map) || []}
						onChange={(val, innerKey) => {
							onTabPickListChange(code, val, innerKey);
						}}
						onCheckAll={(val, innerKey) => {
							onTabPickListChange(code, val, innerKey);
						}}
						checkedList={filterParams[code] || []}
					/>
				);
			case "DIFFICULTY":
				return (
					<PickListDropdown.SinglePickListDropdown
						defaultTitle={name}
						clearable={true}
						options={setDifficultySelectOptions(map) || []}
						onClick={(value, name) => pickListChange(code, value, name)}
						onPickListClear={() => {
							clearFilter(code);
						}}
						value={filterParams[code] || null}
					/>
				);
			case "ISLISTEN":
				return (
					<PickListDropdown.SinglePickListDropdown
						defaultTitle={name}
						options={FormateSinglePickListDropdown(map, code) || []}
						onClick={(value) => pickListChange(code, value)}
						displayType="name"
						onPickListClear={() => {
							clearFilter(code);
						}}
						value={filterParams[code] || null}
					/>
				);
			default:
				return (
					<PickListDropdown.SinglePickListDropdown
						defaultTitle={name}
						clearable={true}
						options={FormateSinglePickListDropdown(map, code) || []}
						onClick={(value) => pickListChange(code, value)}
						onPickListClear={() => {
							clearFilter(code);
						}}
						value={filterParams[code] || null}
					/>
				);
		}
	};

	const toggleDetailVisible = (item) => {
		if (!detailPopup.visible) {
			setBookTagPath("");
			setBookTagIsListen(false);
			const { eduSubject, fileUID, uid } = item;
			setDetailUID(uid);
			sendRecordDetail(FetchEventType.Fetch, {
				eduSubject,
				fileUID,
			});
		}
		setDetailPopup({
			...detailPopup,
			visible: !detailPopup.visible,
		});
	};

	const onSelectBookTag = (path) => {
		const isListen = targetSelectOptions.find((item) => item.value === path).isListen;
		setBookTagPath(path);
		setBookTagIsListen(isListen);
	};
	const onExportBtnClick = () => {
		const version = eduVersion[sendFormData.education].find((item) => item.code === sendFormData.version).name;
		const education = eduMap.find((item) => item.value === sendFormData.education).name;
		const subject = eduSubject[sendFormData.education].find((item) => item.code === sendFormData.subject).name;
		sendExportFile(FetchEventType.Fetch, {
			payload: {
				versionName: version,
				eduSubjectName: `${education}${subject}`,
				questions: quesIDList,
			},
		});
	};

	const downloadURI = (url) => {
		let link = document.createElement("a");
		link.href = url;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	const targetDetail = useMemo(() => {
		if (!detailList) return {};
		return detailList.find((item) => item.uid === detailUID) || {};
	}, [detailUID, detailList]);

	const targetSelectOptions = useMemo(() => {
		let result = [];
		if (Object.keys(targetDetail).length === 0 || !targetDetail.detailImage) return result;

		result =
			targetDetail?.detailImage.map((item) => ({
				name: item.name,
				value: item.path,
				isListen: false,
			})) || [];
		if (targetDetail.soundtracks) {
			const listenList = targetDetail.soundtracks.map((item) => ({
				name: item.name,
				value: item.path,
				isListen: true,
			}));
			result = result.concat(listenList);
		}
		return result;
	}, [targetDetail]);

	useEffect(() => {
		const defaultColumnConfig = userColConfig.length > 0 ? userColConfig : defaultColumnData;
		const nextData = formatTableColData(defaultColumnConfig);
		sendSelect(FetchEventType.Fetch);
		setList(defaultColumnConfig);
		setTableColumn(nextData);
	}, []);

	useEffect(() => {
		if (!questions) return;
		setQuestionData(questions);
	}, [questions]);

	useEffect(() => {
		if (eduVersionOption.length === 0) return;
		setSendFormData({
			...sendFormData,
			version: eduVersionOption[0].value,
		});
	}, [eduVersionOption]);

	useEffect(() => {
		if (eduSubjectOption.length === 0 || !sendFormData.version) return;
		setSendFormData({
			...sendFormData,
			subject: eduSubjectOption[0].value,
		});
	}, [sendFormData.version, eduSubjectOption]);

	useEffect(() => {
		if (stateSelect.matches(FetchStates.Resolved)) {
			setSendFormData({
				...sendFormData,
				year: yearMap[0].value,
				education: eduMap[0].value,
			});
		}
	}, [stateSelect.value]);

	useEffect(() => {
		setDataFetching(stateBankQuestion.matches(FetchStates.Loading));
	}, [stateBankQuestion.value]);

	useEffect(() => {
		if (!allCheckedData) return;
		setCheckedList(allCheckedData);
	}, [allCheckedData]);
	useEffect(() => {
		if (!stateUserAuthorityPreference.matches(FetchStates.Resolved)) return;
		authDispatch(AuthEventType.UpdatingUserProfile);
	}, [stateUserAuthorityPreference.value]);

	useEffect(() => {
		if (targetSelectOptions.length === 0) return;
		setBookTagPath(targetSelectOptions[0].value);
	}, [targetSelectOptions]);

	useEffect(() => {
		if (stateExportFile.matches(FetchStates.Resolved)) {
			downloadURI(fileUrl);
		}
	}, [stateExportFile.value]);

	return (
		<UiQuestionSearchPage>
			<div className="breadBlock">
				<Breadcrumb data={breadcrumbList} />
			</div>
			<div className="searchToolBar">
				<div className="selectSearchGroup">
					<Select
						placeholder="請選擇學年度"
						options={yearMap}
						value={sendFormData.year}
						onChange={(val) => {
							onSelectChange("year", val);
						}}
					/>
					<Select
						placeholder="請選擇學制"
						options={eduMap}
						value={sendFormData.education}
						onChange={(val) => {
							onSelectChange("education", val);
						}}
					/>
					{console.log(eduVersionOption)}
					{eduVersionOption.length > 0 ? (
						<Select
							placeholder="請選擇版本"
							options={eduVersionOption}
							value={sendFormData.version}
							onChange={(val) => {
								onSelectChange("version", val);
							}}
						/>
					) : (
						""
					)}
					{eduSubjectOption.length > 0 ? (
						<Select
							placeholder="請選擇科目"
							options={eduSubjectOption}
							value={sendFormData.subject}
							onChange={(val) => {
								onSelectChange("subject", val);
							}}
						/>
					) : (
						""
					)}
					<Button.IconButton
						variant="blue"
						full={false}
						icon={
							<i className="material-icons" style={{ fontSize: "20px" }}>
								search
							</i>
						}
						onClick={searchBookMap}>
						搜尋
					</Button.IconButton>
				</div>
				<div className="actionBox">
					{filter && filter.length > 0 && (
						<Button.IconButton
							variant="blue"
							full={false}
							icon={
								<i className="material-icons" style={{ fontSize: "20px" }}>
									settings
								</i>
							}
							onClick={() => {
								setModalVisible({
									...modalVisible,
									drag: true,
								});
							}}>
							設定欄位
						</Button.IconButton>
					)}
					<Button.IconButton
						variant="blue"
						full={false}
						icon={
							<i className="material-icons" style={{ fontSize: "20px" }}>
								get_app
							</i>
						}
						loading={stateExportFile.matches(FetchStates.Loading)}
						disabled={quesIDList.length === 0}
						onClick={() => {
							onExportBtnClick();
						}}>
						匯出
					</Button.IconButton>
				</div>
			</div>
			<div className="questionSearchContent">
				<div className="leftSideBar">
					<div className="leftSideBarHeader">範圍</div>
					<div className="leftSideBarContent">
						<CollapseTree
							panelData={bookMap}
							treeData={treeData}
							checkedList={checkedList}
							dataFetching={dataFetching}
							activeKey={treeActiveKey}
							onChange={onChange}
							onPanelChange={onPanelChange}
						/>
					</div>
					<div className="leftSideBarFooter">
						<Button.IconButton
							variant="white"
							icon={
								<i className="material-icons" style={{ fontSize: "20px" }}>
									close
								</i>
							}
							onClick={() => {
								setCheckedList([]);
							}}>
							清除
						</Button.IconButton>
					</div>
				</div>
				<div className="questionSearchMain">
					{filterDisplay && filterDisplay.length > 0 && filterTableData.length > 0 && (
						<div className="filterBar">
							<FilterBar
								prevChildren={
									<Select
										variant={"dark"}
										className="filterSelect"
										options={questionDisplayTypeOptions}
										placeholder="請選擇顯示方式"
										defaultValue={"all"}
										allowClear={false}
										onChange={(val) => {
											setQuestionDisplayType(val);
										}}
									/>
								}
								onChange={(value) => pickListChange("name", value)}>
								{filterDisplay.map((item) => renderFilterBar(item))}
							</FilterBar>
						</div>
					)}

					<div className="questionSearchTableContent">
						<div className="questionSearchTable" ref={tableRef}>
							<Table {...args}>
								{filterTableData.length > 0 ? (
									<Table.Body isSticky={args.isSticky} isLoading={args.isLoading}>
										<Table.Row isSticky={args.isSticky}>
											<Table.Item className={"tableItem checkTableItem"} isSticky={args.isSticky}>
												<div className="tableCheckHeader">圖片</div>
											</Table.Item>
											{Object.entries(tableColumn).map(([key, val]) => (
												<Table.Item className={"tableItem"} key={key}>
													{val.name}
												</Table.Item>
											))}
										</Table.Row>
										{sliceTableData(filterTableData, pageState.currentPage, pageState.limit).map((item, index) => (
											<Table.Row key={`${item.fileUID}${index}`}>
												<Table.Item className="tableItem checkTableItem" isSticky={args.isSticky}>
													<div className="tableCheck">
														<Checkbox
															checked={
																quesIDList.find((ele) => ele.bookID === item.bookID)
																	? quesIDList
																			.find((ele) => ele.bookID === item.bookID)
																			.iDs.findIndex((ele) => ele === item.uid) !== -1
																	: false
															}
															onChange={(event) => {
																tableCheck(event, item);
															}}
														/>
														<Icon
															name="insert_photo"
															type="outLined"
															onClick={() => {
																toggleDetailVisible(item);
															}}
														/>
													</div>
												</Table.Item>
												{Object.entries(tableColumn).map(([key, val]) => {
													let itemText = key === "detailDoc" ? val.defaultValue : item[key] || val.defaultValue;
													return (
														<Table.Item className="tableItem" key={key}>
															{key === "uid" || itemText.length <= 15 ? itemText : `${itemText.substring(0, 14)}...`}
															{item.isListen && key === "QUES_TYPE" && (
																<HeadphonesSolid style={{ color: "#ffb800", marginLeft: "8px" }} />
															)}
														</Table.Item>
													);
												})}
											</Table.Row>
										))}
									</Table.Body>
								) : (
									<div className="tableNoData">
										<img src={`/assets/noData.png`} alt="noData" />
										無資料顯示
									</div>
								)}
							</Table>
						</div>
						<Pagination
							defaultCurrent={1}
							current={pageState.currentPage}
							onChange={pageChange}
							total={filterTableData.length}
							defaultPageSize={pageState.limit}
						/>
					</div>
				</div>
			</div>
			<Modal
				title={
					<>
						<Icon name="settings" type="outLined" />
						<div>設定欄位</div>
					</>
				}
				visible={modalVisible.drag}
				okText="確定"
				cancelText="取消"
				onOk={changeColumn}
				okButtonProps={{ disabled: confirmDisabled }}
				onCancel={() => {
					setModalVisible({
						...modalVisible,
						drag: false,
					});
				}}>
				<DragDropList
					label={
						<div>
							自定義所需欄位，以拖曳的方式調整欄位順序<span style={{ color: "#ddd" }}>（註：預設欄位無法刪除）</span>
						</div>
					}
					list={list}
					options={subtraction(columnOptions, list || [])}
					onChange={onDragEndChange}
					onAdd={onAdd}
					onDelete={onDelete}
					onSelectChange={onDragDropSelectChange}
				/>
			</Modal>

			<UiQuesDetail id="quesDetail">
				<Modal
					visible={detailPopup.visible}
					onCancel={toggleDetailVisible}
					getContainer={document.getElementById("quesDetail")}
					width="75%"
					footer={null}>
					<UiPopupContainer id="quesTab">
						<Tabs
							defaultActiveKey="1"
							tabBarExtraContent={
								<>
									{targetDetail?.questionPdf ? (
										<Button.IconButton
											variant="blue"
											type="outLined"
											iconName="picture_as_pdf"
											onClick={() => {
												window.open(targetDetail.questionPdf, "_blank");
											}}>
											PDF
										</Button.IconButton>
									) : (
										""
									)}
								</>
							}>
							<Tabs.TabPane
								tab={
									<>
										<Icon name="visibility" />
										檢視更多
									</>
								}
								key="1">
								<div className="container">
									<div className="content">
										<div className="title">題目</div>
										<div className="img">
											<Image
												src={targetDetail?.questionImage || "error"}
												preview={{
													getContainer: document.getElementById("quesTab"),
												}}
												fallback="data:image/png;base64,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"
											/>
										</div>
										<ul className="info">
											<li>
												入庫時間:{" "}
												{targetDetail?.createTime && format(new Date(targetDetail.createTime), "yyyy-MM-dd HH:mm")}
											</li>
											<li>最後修改時間: {targetDetail?.updateTime}</li>
										</ul>
									</div>
									<div className="content">
										<div className="title">基本資料</div>
										<div className="meta">
											編號:
											<span className="metaContent">{targetDetail?.uid}</span>
										</div>
										{targetDetail?.metadata &&
											targetDetail.metadata.map((meta, index) => {
												return (
													<div className="meta" key={index}>
														{`${meta.name}: `}
														{meta.content.map((content, contentIndex) => {
															return (
																<span className="metaContent" key={contentIndex}>
																	{new Set(showCodeList).has(meta.code) ? content.code : content.name}
																</span>
															);
														})}
													</div>
												);
											})}
									</div>
								</div>
							</Tabs.TabPane>
							<Tabs.TabPane
								tab={
									<>
										<Icon name="widgets" />
										解析狀態
									</>
								}
								key="2">
								<div className="container">
									<div className="content">
										<div className="title">題目</div>
										<div className="bookTag">
											<Select
												label="解析書籤名稱:"
												options={targetSelectOptions}
												value={bookTagPath}
												onChange={(val) => {
													onSelectBookTag(val);
												}}
											/>
										</div>
										<div className="img">
											{bookTagIsListen ? (
												<audio controls src={bookTagPath || "error"}>
													Your browser does not support the
													<code>audio</code> element.
												</audio>
											) : (
												<Image
													src={bookTagPath || "error"}
													preview={{
														getContainer: document.getElementById("quesTab"),
													}}
													fallback="data:image/png;base64,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"
												/>
											)}
										</div>
									</div>
									<div className="content">
										<div className="title">基本資料</div>
										<div className="meta">
											編號:
											<span className="metaContent">{targetDetail?.uid}</span>
										</div>
										{targetDetail?.metadata &&
											targetDetail.metadata.map((meta, index) => {
												return (
													<div className="meta" key={index}>
														{`${meta.name}: `}
														{meta.content.map((content, contentIndex) => {
															return (
																<span className="metaContent" key={contentIndex}>
																	{new Set(showCodeList).has(meta.code) ? content.code : content.name}
																</span>
															);
														})}
													</div>
												);
											})}
									</div>
								</div>
							</Tabs.TabPane>
						</Tabs>
					</UiPopupContainer>
				</Modal>
			</UiQuesDetail>
		</UiQuestionSearchPage>
	);
};
